import { filterEntries } from "@/views/person/filterEntries.js";
import useLegacyIdRedirect from "@/util/useLegacyIdRedirect.ts";
import { useStore } from "vuex";

export default function useCategoryRedirect() {
  const store = useStore();
  const { checkForLegacyIdAndRedirect } = useLegacyIdRedirect();

  function categoryRedirect(to) {
    const { categoryID } = to.params;

    const category = store.getters["api/category"](categoryID);

    const defaultRouteParams = {
      styleid: store.getters.getStyleID,
    };

    checkForLegacyIdAndRedirect(categoryID, null);

    const items = filterEntries(category.entries, store, categoryID);

    if (items.length && !store.getters.showCMS) {
      // if only one entry go directly into the route
      if (
        items.length === 1 &&
        category.layout !== "PersonBannersLayout" &&
        category.layout !== "PersonListCategoryLayout" &&
        category.layout !== "PersonListCategoryLayout2" &&
        category.layout !== "RecordsColumnsLayout" &&
        category.layout !== "RecordsRowsLayout"
      ) {
        // if its a back button then go up a level
        if (to.query.backButton) {
          // if it has a parent category ID go to subcategory otherwise go to categories
          if (category.parentCategoryID !== null) {
            return {
              name: "SubCategories",
              params: {
                ...defaultRouteParams,
                categoryID: category.parentCategoryID,
              },
              query: { backButton: "true" },
            };
          }
          return {
            name: "Categories",
            params: defaultRouteParams,
            query: { backButton: "true" },
          };
        }
        return {
          name: "Person",
          params: {
            ...defaultRouteParams,
            categoryID,
            entryID: items[0].path.split("/")[2],
          },
        };
      }
    }

    return undefined;
  }

  return {
    categoryRedirect,
  };
}
